import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _BusinessSpendManagementFilledIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        d="M18.5 18.7505C18.5 17.784 17.7165 17.0005 16.75 17.0005C15.7835 17.0005 15 17.784 15 18.7505C15 19.717 15.7835 20.5005 16.75 20.5005C17.7165 20.5005 18.5 19.717 18.5 18.7505ZM20.5 18.7505C20.5 20.8216 18.8211 22.5005 16.75 22.5005C14.6789 22.5005 13 20.8216 13 18.7505C13 16.6794 14.6789 15.0005 16.75 15.0005C18.8211 15.0005 20.5 16.6794 20.5 18.7505Z"
        fill={iconColor}
      />
      <Path
        d="M18.293 20.2935C18.6591 19.9273 19.2381 19.9047 19.6309 20.2251L19.707 20.2935L21.207 21.7935L21.2754 21.8696C21.5957 22.2624 21.5731 22.8414 21.207 23.2075C20.8409 23.5736 20.2619 23.5962 19.8691 23.2759L19.793 23.2075L18.293 21.7075L18.2246 21.6313C17.9043 21.2386 17.9269 20.6596 18.293 20.2935Z"
        fill={iconColor}
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 1.00049C20.1046 1.00049 21 1.89592 21 3.00049V16.6294C20.2207 15.0711 18.6109 14.0005 16.75 14.0005C14.1267 14.0005 12 16.1271 12 18.7505C12 19.66 12.2559 20.5097 12.6992 21.2319C12.1427 21.4085 11.5022 21.254 11.0938 20.7671L9.55859 18.936C8.92545 18.1814 7.76655 18.1724 7.12207 18.9175L4.75586 21.6528C4.15004 22.3532 3.00037 21.9254 3 20.9995V3.00049C3 1.89592 3.89543 1.00049 5 1.00049H19ZM8.75 10.0005C8.33579 10.0005 8 10.3363 8 10.7505C8 11.1647 8.33579 11.5005 8.75 11.5005H15.25C15.6642 11.5005 16 11.1647 16 10.7505C16 10.3363 15.6642 10.0005 15.25 10.0005H8.75ZM7.75 6.00049C7.33579 6.00049 7 6.33627 7 6.75049C7 7.1647 7.33579 7.50049 7.75 7.50049H16.25C16.6642 7.50049 17 7.1647 17 6.75049C17 6.33627 16.6642 6.00049 16.25 6.00049H7.75Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const BusinessSpendManagementFilledIcon = assignWithoutSideEffects(
  _BusinessSpendManagementFilledIcon,
  {
    componentId: 'BusinessSpendManagementFilledIcon',
  },
);

export default BusinessSpendManagementFilledIcon;
